const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const FILTERS = [
  { title: "All Genres", by: "genre" },
  { title: "All Languages", by: "lang" },
  { title: "All Producers", by: "producer" },
  { title: "All Countries", by: "country" },
];

const INITIAL_PAGINATION_DATA = {
  data: [],
  links: {},
  meta: {},
};

const INITIAL_PLAYER_STATE = {
  pip: false,
  playing: false,
  controls: false,
  light: false,
  volume: 0.8,
  muted: false,
  played: 0,
  playedSeconds: 0,
  loaded: 0,
  duration: 0,
  playbackRate: 1.0,
  loop: false,
};

const PLAYBACK_RATES = [0.25, 0.5, 0.75, 1.0, 1.25, 1.5, 1.75, 2];

const QUALITIES = ["Low", "SD", "HD", "FHD", "4K"];

export {
  API_BASE_URL,
  FILTERS,
  INITIAL_PAGINATION_DATA,
  INITIAL_PLAYER_STATE,
  PLAYBACK_RATES,
  QUALITIES,
};
